import { render, staticRenderFns } from "./MatchedInfo.vue?vue&type=template&id=24e3a87e&scoped=true"
import script from "./MatchedInfo.vue?vue&type=script&lang=js"
export * from "./MatchedInfo.vue?vue&type=script&lang=js"
import style0 from "./MatchedInfo.vue?vue&type=style&index=0&id=24e3a87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3a87e",
  null
  
)

export default component.exports